export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"author","name":"author","content":"Freegle"},{"name":"supported-color-schemes","content":"light"},{"name":"color-scheme","content":"light"},{"name":"facebook-domain-verification","content":"zld0jt8mvf06rt1c3fnxvls3zntxj6"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"description","name":"description","content":"Give and get stuff for free in your local community.  Don't just recycle - reuse, freecycle and freegle!"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Give and get stuff for free in your local community.  Don't just recycle - reuse, freecycle and freegle!"},{"hid":"og:image","property":"og:image","content":"https://www.ilovefreegle.org/icon.png"},{"hid":"og:locale","property":"og:locale","content":"en_GB"},{"hid":"og:title","property":"og:title","content":"Freegle - Don't throw it away, give it away!"},{"hid":"og:site_name","property":"og:site_name","content":"Freegle"},{"hid":"og:url","property":"og:url","content":"https://www.ilovefreegle.org"},{"hid":"fb:app_id","property":"fb:app_id","content":"134980666550322"},{"hid":"og:description","property":"og:description","content":"Give and get stuff for free in your local community.  Don't just recycle - reuse, freecycle and freegle!"},{"hid":"fb:app_id","property":"og:site_name","content":"134980666550322"},{"hid":"twitter:title","name":"twitter:title","content":"Freegle - Don't throw it away, give it away!"},{"hid":"twitter:description","name":"twitter:description","content":"Give and get stuff for free in your local community.  Don't just recycle - reuse, freecycle and freegle!"},{"hid":"twitter:image","name":"twitter:image","content":"https://www.ilovefreegle.org/icon.png"},{"hid":"twitter:image:alt","name":"twitter:image:alt","content":"The Freegle logo"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:site","name":"twitter:site","content":"thisisfreegle"},{"hid":"OMG-Verify-V1","name":"OMG-Verify-V1","content":"954a2917-d603-4df4-8802-f6a78846a9c0"},{"hid":"Awin","name":"Awin","content":"Awin"}],"link":[],"style":[],"script":[],"noscript":[],"title":"Freegle - Don't throw it away, give it away!"}

export const appCdnURL = "/netlify/65e3b844cf8299000875c5ed--golden-caramel-d2c3a7.netlify.app"

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false